module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-55Rg.42a2c2c.eot";